import React from 'react';
import Seat from '../../../components/Seat';
import WagonStairs from '../../../components/WagonStairs';
import WagonBaggage from '../../../components/WagonBaggage';

function SecondFloor({
  seats,
  chosenSeats,
  setChosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>II</h2>
        </div>

        <div
          className="seats-row right"
          style={{ width: '755.3px', marginRight: '100px' }}
        >
          <WagonStairs style={{ marginRight: '29px' }} />
          <div className="seat-column">
            <Seat
              seat={seats?.[76]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[77]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed" style={{ marginLeft: '17px' }}>
            <Seat
              seat={seats?.[75]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[74]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[73]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[72]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[70]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[71]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[69]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[68]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[67]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[66]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[64]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[65]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[62]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[63]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[60]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[61]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[58]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[59]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[56]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[57]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed" style={{ marginLeft: '17px' }}>
            <Seat
              seat={seats?.[55]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[54]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <WagonStairs style={{ marginLeft: '29px' }} />
        </div>
        <div
          className="seats-row right bottom"
          style={{ width: '755.3px', marginRight: '100px' }}
        >
          <div className="seat-column">
            <Seat
              seat={seats?.[116]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[115]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[114]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed" style={{ marginLeft: '17px' }}>
            <Seat
              seat={seats?.[111]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[112]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[113]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[108]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[109]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[110]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[105]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[106]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[107]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[102]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[103]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[104]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed">
            <Seat
              seat={seats?.[99]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[100]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[101]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <WagonBaggage
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          />
          <div className="seat-column">
            <Seat
              seat={seats?.[98]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[97]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[96]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[95]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[94]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[93]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[92]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[91]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[90]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[89]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[88]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[87]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[86]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[85]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[84]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column">
            <Seat
              seat={seats?.[83]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[82]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[81]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
          <div className="seat-column reversed" style={{ marginLeft: '17px' }}>
            <Seat
              seat={seats?.[78]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[79]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
            />
            <Seat
              seat={seats?.[80]}
              chosenSeats={chosenSeats}
              setChosenSeats={setChosenSeats}
              wagonNumber={wagonNumber}
              reserveSeat={reserveSeat}
              unReserveSeat={unReserveSeat}
              bottom
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SecondFloor;
